import clientFailedSharesConstants from "../constants/clientFailedSharesConstants";

export const getClientFailedShares = (payload: any) => ({
    type: clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_REQUEST,
    payload,
});

export const resetClientFailedShares = () => ({
    type: clientFailedSharesConstants.RESET_CLIENT_FAILED_SHARES,
});
